import { render, staticRenderFns } from "./SalesRefundCRMReports.vue?vue&type=template&id=fd6c5d9c&scoped=true"
import script from "./SalesRefundCRMReports.vue?vue&type=script&lang=js"
export * from "./SalesRefundCRMReports.vue?vue&type=script&lang=js"
import style0 from "./SalesRefundCRMReports.vue?vue&type=style&index=0&id=fd6c5d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6c5d9c",
  null
  
)

export default component.exports